/**
 * @since 2025-02-19
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import DialogConfirmJobAction from "components/Shared/DialogConfirmJobAction";
import { useState } from "react";
import "./MenuSelection.scss";

const MenuSelection = ({
  onCancelSelection,
  onSetRun,
  onSetForceStart,
  onSetOk,
  onSetWarning,
  onSetError,
  listJobSelected,
}) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const [actionName, setActionName] = useState("");
  const [actionCallback, setActionCallback] = useState(null);

  const handleAction = (name, callback) => {
    setActionName(name);
    setActionCallback(() => callback);
    setShowConfirm(true);
  };

  const confirmAction = () => {
    setShowConfirm(false);
    actionCallback();
  };

  const cancelConfirm = () => {
    setShowConfirm(false);
  };

  return (
    <div className="menu-selection-container">
      <div className="menu-selection-toolbar">
        <button
          className="menu-button cancel"
          onClick={() => onCancelSelection()}
        >
          Cancel Selection
        </button>
        <button
          className="menu-button running"
          onClick={() => handleAction("re-run", onSetRun)}
        >
          Re-run
        </button>
        <button
          className="menu-button ok"
          onClick={() => handleAction("set as OK", onSetOk)}
        >
          Set as OK
        </button>
        <button
          className="menu-button warning"
          onClick={() => handleAction("set as warning", onSetWarning)}
        >
          Set as Warning
        </button>
        <button
          className="menu-button error"
          onClick={() => handleAction("set as error", onSetError)}
        >
          Set as Error
        </button>
        <button
          className="menu-button running"
          onClick={() => handleAction("force start", onSetForceStart)}
        >
          Force Start
        </button>
      </div>

      {showConfirm && (
        <div className="modal-overlay">
          <DialogConfirmJobAction
            listJobs={listJobSelected}
            actionName={actionName}
            onActionConfirmed={confirmAction}
            onActionCanceled={cancelConfirm}
          />
        </div>
      )}
    </div>
  );
};

export default MenuSelection;
